import logo from "../../assets/pictures/visper-logo.svg";
import routes from "../../routs";
import styles from "./Header.module.scss";

const Header: React.FC = () => {
	return (
		<div className={styles.headerContainer}>
			<a href={routes.home}>
				<img src={logo} alt="visper logo" className={styles.headerLogo} />
			</a>
		</div>
	);
};

export default Header;
